import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Navigation } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { deVille } from "../data/cities974.mjs";

export const CityLocalSection = ({ local }) => (
  <section className="py-20 md:py-28 bg-[#09090b] border-t border-amber-500/10" data-testid="city-local-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle eyebrow={`${local.name} · ${local.cp}`} title="Votre marabout" gold={local.name}
        subtitle={`Maître Diamma intervient dans tous les quartiers ${deVille(local.name)}, dans ${local.zone} de La Réunion.`} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Reveal>
          <div className="lux-card h-full p-8" data-testid="city-quartiers">
            <h3 className="font-heading text-lg text-amber-100 mb-5 flex items-center"><MapPin className="w-5 h-5 text-amber-400 mr-2" />Quartiers desservis</h3>
            <div className="flex flex-wrap gap-2">
              {local.quartiers.map((q) => (
                <span key={q} className="px-3 py-1.5 rounded-full text-sm border border-amber-500/20 text-amber-200/90">{q}</span>
              ))}
            </div>
          </div>
        </Reveal>
        <Reveal delay={120}>
          <div className="lux-card h-full p-8" data-testid="city-voisines">
            <h3 className="font-heading text-lg text-amber-100 mb-5 flex items-center"><Navigation className="w-5 h-5 text-amber-400 mr-2" />Communes voisines</h3>
            <div className="flex flex-wrap gap-2">
              {local.voisins.map((v) => (
                <Link key={v.key} to={`/marabout-${v.key}`} data-testid={`city-voisine-${v.key}`}
                  className="px-3 py-1.5 rounded-full text-sm border border-zinc-700 text-zinc-300 hover:text-amber-300 hover:border-amber-500/40 transition-colors duration-300">
                  Marabout {v.name}
                </Link>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
